// src/pages/xray/XrayLobby/DeviceOverview.js
import React from 'react';

const DeviceOverview = ({ deviceOverview }) => {
  const handleCopy = value => {
    navigator.clipboard.writeText(value || '');
  };

  const keys = [
    ['HOSTNAME', deviceOverview?.hostname],
    ['UPTIME', deviceOverview?.Uptime],
    ['LAN MAC', deviceOverview?.['LAN MAC']],
    ['MODEL', deviceOverview?.Model],
    ['REGSERVER-1', deviceOverview?.['regserver-1']],
    ['SIP PROXY PORT', deviceOverview?.['SIP Proxy Port']],
    ['SNMP COMMUNITY', deviceOverview?.['snmp Community']],
    ['VOICE VLAN', deviceOverview?.['Voice vlan']],
    ['PRIMARY WAN IP', deviceOverview?.['Primary Wan Ip']],
    ['SECONDARY WAN IP', deviceOverview?.['Secondary Wan Ip']],
    ['PASSTHROUGH RULES', deviceOverview?.['Passthrough Rules']],
    ['PROXY ARP', deviceOverview?.['Proxy ARP']],
    ['USER COMMANDS', deviceOverview?.['User Commands']],
    ['VOS Image Version', deviceOverview?.['VOS Image Version']],
    ['TO BE DETERMINED', deviceOverview?.['TO BE DETERMINED']],
    ['TO BE DETERMINED 2', deviceOverview?.['TO BE DETERMINED 2']],
  ];

  return (
    <div className="grid grid-cols-4 gap-4 mt-4">
      {keys.map(([key, value], index) => {
        const isUptime = key.toLowerCase() === 'uptime';
        const isSipProxyPort =
          key.toLowerCase() === 'sip proxy port' && value?.trim() === '5075';
        return (
          <div
            key={index}
            className="p-4 border rounded-lg shadow-md bg-gray-50 hover:bg-gray-100 overflow-hidden break-words max-w-full h-24 flex flex-col justify-between cursor-pointer transition-transform transform hover:scale-105 duration-300 ease-in-out"
            onClick={() => handleCopy(value)}
            title="Click to copy"
          >
            <h2 className="font-bold">{key.toUpperCase()}</h2>
            <p
              className={`text-gray-600 ${
                isUptime ? 'text-red-600 font-semibold text-xl' : ''
              }`}
            >
              {value || 'Not found'}
              {isSipProxyPort && (
                <span className="text-blue-600 font-semibold ml-2 text-xl">
                  EZPBX9
                </span>
              )}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default DeviceOverview;
